export default "__VITE_ASSET__BpoAA2VT__"